import { render, staticRenderFns } from "./ProposalFilters.vue?vue&type=template&id=1726c910&scoped=true"
import script from "./ProposalFilters.vue?vue&type=script&lang=js"
export * from "./ProposalFilters.vue?vue&type=script&lang=js"
import style0 from "./ProposalFilters.vue?vue&type=style&index=0&id=1726c910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726c910",
  null
  
)

export default component.exports